import React                   from 'react';
import classNames              from 'classnames';
import { Observe }             from 'rewire-core';
import {
  WithStyle,
  IActionMenuItem,
}                              from 'rewire-ui';
import Button                  from '@material-ui/core/Button';
import Link                    from '@material-ui/core/Link';
import { Theme }               from '@material-ui/core/styles';
import Typography              from '@material-ui/core/Typography';
import FilterListIcon          from '@material-ui/icons/FilterListOutlined';
import SaveIcon                from '@material-ui/icons/SaveOutlined';
import PrioritySortMenu        from '../ui/PrioritySortMenu';
import PriorityGroupMenu       from '../ui/PriorityGroupMenu';
import OptionsActionMenu       from '../ui/OptionsActionMenu';
import scheduleControlsModel   from './ScheduleControlsModel';
import ScheduleFilterDialog    from './ScheduleFilterDialog';
import { withStyles }          from '../utility/styles';

const styles = (theme: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    flex: '0 0 auto',
  },
  highlight: {
    color: theme.palette.error.main,
  },
  scheduleButtons: {
    display: 'flex',
    flex: '0 0 auto',
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    marginBottom: '7px',
    // paddingLeft: '50px',
  },
  scheduleButtonsButton: {
    minWidth: '0px',
    minHeight: '0px',
    padding: '0px',
    marginLeft: '15px',
  },
  removeFiltersContainer: {
    marginBottom: '3px',
  },
  removeFiltersButton: {
    cursor: 'pointer',
  },
  hasSelection: {
    color: theme.palette.secondary.main
  }
});

interface IScheduleControlsProps {
  hideFilterBy?:   boolean;
  hideGroupBy?:    boolean;
  hideSortBy?:     boolean;
  hideActionMenu?: boolean;
  classes?:        any;
}

type ScheduleControlsProps = WithStyle<ReturnType<typeof styles>, IScheduleControlsProps>;

class ScheduleControls extends React.PureComponent<ScheduleControlsProps> {
  scheduleOptionsItemsGroup:  IActionMenuItem[];
  scheduleOptionsItemsSearch: IActionMenuItem[];
  scheduleOptionsItemsView:   IActionMenuItem[];

  constructor(props: ScheduleControlsProps) {
    super(props);

    this.scheduleOptionsItemsGroup = [
      {name: 'saveLayoutAsDefault', title: 'Save Layout as Default', icon: SaveIcon, onClick: this.saveLayoutAsDefault, closeOnClick: true},
    ];

    this.scheduleOptionsItemsSearch = [
      {name: 'saveView', title: 'Save View', icon: SaveIcon, onClick: this.showSearchViewDialog, disabled: () => !scheduleControlsModel.canAddViews && !scheduleControlsModel.canEditViews, closeOnClick: true},
    ];

    this.scheduleOptionsItemsView = [
      {name: 'placeholder', title: 'Placeholder', onClick: undefined, disabled: () => true, closeOnClick: true},
    ];
  }

  saveLayoutAsDefault = () => {
    scheduleControlsModel.saveLayoutAsDefault();
  };

  showSearchViewDialog = () => {
    scheduleControlsModel.showSearchViewDialog();
  };

  clearFilters = () => {
    scheduleControlsModel.clearFilters();
  };

  showFilterDialog = () => {
    scheduleControlsModel.showFilterDialog();
  };

  render() {
    const { classes } = this.props;

    return <Observe render={() => {
      const {
        hideFilterBy,
        hideGroupBy,
        hideSortBy,
        hideActionMenu
      } = this.props;

      return (
        <div className={classes.root}>
          <Observe render={() => (
            scheduleControlsModel.hasFilters &&
              <div className={classes.removeFiltersContainer}>
                <Typography variant='caption' className={classes.highlight}>Filters Applied.</Typography><Typography variant='caption'> To view all, <Link onClick={this.clearFilters} className={classes.removeFiltersButton} variant='caption' underline='always'>Clear Filters</Link></Typography>
              </div>
          )} />
          <div className={classes.scheduleButtons}>
            { !hideFilterBy && <Button title='Filter By' className={classNames(classes.scheduleButtonsButton, scheduleControlsModel.hasFilters ? classes.hasSelection : undefined)} onClick={this.showFilterDialog}><FilterListIcon /></Button> }
            { !hideGroupBy  && <PriorityGroupMenu model={scheduleControlsModel.groupModel} classes={{menuButton: classes.scheduleButtonsButton}} /> }
            { !hideSortBy   && <PrioritySortMenu model={scheduleControlsModel.sortModel} classes={{menuButton: classes.scheduleButtonsButton}} /> }

            {!hideActionMenu &&
              <Observe render={() => <OptionsActionMenu
                title='More Options'
                tooltip='More Options'
                classes={{menuButton: classes.scheduleButtonsButton}}
                items={
                  scheduleControlsModel.mode === 'group'
                    ? this.scheduleOptionsItemsGroup
                    : scheduleControlsModel.mode === 'search'
                      ? this.scheduleOptionsItemsSearch
                      : this.scheduleOptionsItemsView
                } />
              }/>
            }
            <ScheduleFilterDialog />
          </div>
        </div>
      );
    }} />;
  }
}

export default withStyles<IScheduleControlsProps>(styles, ScheduleControls);
